export default "__VITE_ASSET__7607a134__"